import { LOCAL_STORAGE } from "@/config/constants";
import { authService } from "@/features/auth/services/authService";
import { getLocal } from "@/helpers/localStore";
import { logger } from "@/helpers/loggerHelper";

type LogoutUserId = string | number | null | undefined;

export const notifyOpenLogout = async (userId: LogoutUserId) => {
  try {
    const jwtToken = getLocal(LOCAL_STORAGE.TOKEN_NAME);
    if (userId == null || jwtToken == null || jwtToken === "") return;

    await authService.openLogout({
      userId: String(userId),
      jwt_token: jwtToken,
    });
  } catch (err) {
    logger.error("Error in notifyOpenLogout", { err });
  }
};
